import { addDays } from "date-fns/esm";
import { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap"
import DateRangePicker from "../../components/DateRangePicker";
import VoucherService from "../../services/VoucherService";
import useAppContext from "../../hooks/useAppContext";
import { DatasetChart, LineChart } from "../../components/ChartJS";
import Utils from "../../utils/Utils";
import Configs from "../../Configs";

function MyVoucherDashboardModal(props: {
    show: boolean,
    onClose: () => void
}) {
    const { state } = useAppContext()
    const [dateReport, setDateReport] = useState<{
        startDate: Date,
        endDate: Date
    }>({
        startDate: addDays(new Date(), -Configs.DEFAULT_LAST_DAYS + 1),
        endDate: new Date()
    })

    const handleDateChange = (startDate?: Date, endDate?: Date) => {
        if (startDate && endDate) {
            setDateReport({ startDate, endDate })
        }
    }

    useEffect(() => {
        if (props.show) {
            DailyActiveMyVouchersReport(dateReport.startDate, dateReport.endDate)
        }
    }, [props.show, dateReport])

    const DailyActiveMyVouchersReport = async (start: Date, end: Date) => {
        if (state.currentProviderId) {
            const res = await VoucherService.dailyActiveMyVouchersReport(state.currentProviderId, start, end)

            if (res?.isSuccess) {
                generateVoucherQuantityChartData(res.data)
                generateVoucherAmountChartData(res.data)
            } else {
                console.log(res.message);
            }
        }
    }

    const [voucherQuantityChartData, setVoucherQuantityChartData] = useState({
        title: "SALES VOLUME",
        labels: [] as string[],
        datasets: [] as DatasetChart[]
    })

    const generateVoucherQuantityChartData = (source: any) => {
        const data = source as {
            date: Date,
            quantity: number,
            amount: number
        }[]

        const labels = [] as string[]
        const dataset = {
            label: "Volume",
            data: []
        } as DatasetChart

        data.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()).forEach(item => {
            labels.push(Utils.dateToString(item.date, Configs.DATE_FORMAT))
            dataset.data.push(item.quantity)
        })

        var sum = dataset.data.reduce((a, b) => a + b, 0)
        var title = `SALES VOLUME (Total: ${Utils.formatNumber(sum)})`

        setVoucherQuantityChartData({ ...voucherQuantityChartData, title: title, labels: labels, datasets: [dataset] })
    }

    const [voucherAmountChartData, setVoucherAmountChartData] = useState({
        title: "SALES REVENUE",
        labels: [] as string[],
        datasets: [] as DatasetChart[]
    })

    const generateVoucherAmountChartData = (source: any) => {
        const data = source as {
            date: Date,
            quantity: number,
            amount: number
        }[]

        const labels = [] as string[]
        const dataset = {
            label: "Revenue",
            data: []
        } as DatasetChart

        data.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()).forEach(item => {
            labels.push(Utils.dateToString(item.date, Configs.DATE_FORMAT))
            dataset.data.push(item.amount)
        })

        var sum = dataset.data.reduce((a, b) => a + b, 0)
        var title = `SALES REVENUE (Total: ${Utils.formatNumber(sum)})`

        setVoucherAmountChartData({ ...voucherAmountChartData, title: title, labels: labels, datasets: [dataset] })
    }

    return (
        <Modal show={props.show} onHide={props.onClose} backdrop="static" keyboard={false} size="xl">
            <Modal.Header closeButton className="p-2">
                <Modal.Title><i className="fas fa-chart-line"></i> My Voucher Sales Report</Modal.Title>
            </Modal.Header>
            <Modal.Header className="p-2">
                <DateRangePicker startDate={dateReport.startDate} endDate={dateReport.endDate} onChange={handleDateChange} closeOnSelected={true}></DateRangePicker>
            </Modal.Header>
            <Modal.Body className="p-2">
                <Row>
                    <Col lg={12}>
                        <LineChart title={voucherAmountChartData.title} labels={voucherAmountChartData.labels} datasets={voucherAmountChartData.datasets}></LineChart>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <LineChart title={voucherQuantityChartData.title} labels={voucherQuantityChartData.labels} datasets={voucherQuantityChartData.datasets}></LineChart>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    )
}

export default MyVoucherDashboardModal